module.exports = __webpack_public_path__ + "img/img-2.fda2b157.webp";